// extracted by mini-css-extract-plugin
module.exports = {"primary":"#5cb89d","darkgray":"#17191c","warning":"#ff6565","main":"#0A1014","c1":"#f9f9fe","c2":"#f1f1f6","c3":"#d9d9de","c4":"#d1d1d8"};